// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".common-cls1___e194b61efc3fdf405ee{/*!*/}.common-cls2__f3ed8da2c86b51dd1a52{height:22px;width:22px;margin-right:8px;flex-shrink:0;background-image:url(\"/images/premium/Lock-CircleWhite-Blue.svg\");background-size:cover}@media(max-width: 991px){.common-cls2__f3ed8da2c86b51dd1a52{background-image:url(\"/images/premium/Lock-CircleGold-White.svg\")}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "common-cls1___e194b61efc3fdf405ee",
	"cls2": "common-cls2__f3ed8da2c86b51dd1a52 common-cls1___e194b61efc3fdf405ee"
};
export default ___CSS_LOADER_EXPORT___;
